export default "__VITE_ASSET__f80d460a__"